import MuiTextField, { type StandardTextFieldProps } from '@mui/material/TextField';
import { mergeSlotProps } from '@mui/material/utils';

export type TextFieldProps = Partial<StandardTextFieldProps> & { 'data-test'?: string };

export const TextField = ({ slotProps, ...props }: TextFieldProps): JSX.Element => {
  const defaultProps = {
    'data-test': props['data-test'],
    variant: 'standard',
  } as TextFieldProps;

  return (
    <MuiTextField
      {...defaultProps}
      {...props}
      slotProps={{
        ...slotProps,
        inputLabel: mergeSlotProps(slotProps?.inputLabel, { disableAnimation: true, shrink: true }),
        input: mergeSlotProps(slotProps?.input, { disableUnderline: true }),
      }}
    />
  );
};
